import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import vigilMechanismData from "../content/vigilMechanismData.json";

const VigilMechanism = () => {
  const { title, sections } = vigilMechanismData;
  return (
    <>
      <Breadcrumb
        title="Vigil Mechanism"
        items={[{ name: "Home", link: "/" }, { name: "Vigil Mechanism" }]}
      />
      <div className="max-w-7xl mx-auto py-4 text-gray-700">
        {sections.map((section, index) => (
          <div key={index} className="my-5">
            <h3 className="font-medium text-2xl mt-9">{section.heading}</h3>
            <div className="border-box mt-1"></div>

            {section.paragraphs?.map((p, i) => (
              <p key={i} className="mt-5 font-normal">
                {p}
              </p>
            ))}

            {section.list && (
              <div className="responsibilities-content">
                <ul className="list-disc ml-8 mt-4">
                  {section.list.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default VigilMechanism;
